/** Slugify text for filename use (ASCII, lowercase, hyphenated). */
export function slug(text: string): string {
    return text
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-zA-Z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .toLowerCase()
}

/** Ensure the filename ends in `.pdf` (case-insensitive on input). */
export function withExtension(filename: string): string {
    return `${filename.replace(/\.pdf$/i, '')}.pdf`
}

/** Download a PDF Blob as a file. Caller owns the filename. Browser-only. */
export function downloadPDF(filename: string, blob: Blob): void {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}
